import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

// Catch-all route. Previously any unmatched URL rendered nothing (blank white
// screen). This friendly fallback guarantees users always see something.
export default function NotFoundRoute() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4" data-testid="not-found-route">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center">
        <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-blue-50 flex items-center justify-center">
          <Compass className="w-7 h-7 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-800 mb-2">Page not found</h1>
        <p className="text-slate-500 mb-6">
          The link may be broken or expired. If a contractor or project owner sent
          you this link, ask them to resend the latest one.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors"
          data-testid="not-found-home-link"
        >
          Go to homepage
        </Link>
      </div>
    </div>
  );
}
